import { render, staticRenderFns } from "./RepseVendorTable.vue?vue&type=template&id=1aeaa001"
import script from "./RepseVendorTable.vue?vue&type=script&lang=js"
export * from "./RepseVendorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports